export default "::ng-deep .p-tooltip {\n  position: fixed;\n}\n";